<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" md="4" lg="3">
                <v-select
                    v-model="document.typeId"
                    :items="types"
                    label="Rodzaj dokumentu"
                    item-value="id"
                    item-text="name"
                    dense
                    :loading="loading.types"
                    :error="validationState.typeId.error"
                    :error-messages="validationState.typeId.messages"
                    no-data-text="Nie znaleziono rodzajów"
                    :disabled="isReadOnly"
                    @blur="emitFieldBlur('typeId')"
                />
            </v-col>
            <v-col cols="12" md="4" lg="3">
                <v-select
                    v-model="document.productionDepartmentId"
                    :items="productionDepartments"
                    label="Dział"
                    item-value="id"
                    item-text="name"
                    dense
                    :loading="loading.departments"
                    :error="validationState.productionDepartmentId.error"
                    :error-messages="validationState.productionDepartmentId.messages"
                    no-data-text="Nie znaleziono działu"
                    :disabled="isReadOnly"
                    @blur="emitFieldBlur('productionDepartmentId')"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="4" lg="3">
                <v-menu
                    v-model="proposedDatePicker"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    bottom
                    nudge-bottom="40"
                    nudge-right="34"
                    min-width="290px"
                    :disabled="isReadOnly"
                >
                    <template #activator="{on}">
                        <v-text-field
                            :value="formatDate(document.proposedDate, false, false)"
                            label="Proponowany termin"
                            prepend-icon="mdi-calendar"
                            :disabled="isReadOnly"
                            outlined
                            dense
                            :error="validationState.proposedDate.error"
                            :error-messages="validationState.proposedDate.messages"
                            v-on="on"
                            @blur="emitFieldBlur('proposedDate')"
                        />
                    </template>
                    <v-date-picker
                        :value="proposedDate"
                        no-title
                        scrollable
                        :min="new Date().toISOString().split('T')[0]"
                        first-day-of-week="1"
                        :disabled="isReadOnly"
                        @input="proposedDateHandler"
                    />
                </v-menu>
            </v-col>
            <v-col v-if="showStatusSelector" cols="12" md="4" lg="3">
                <v-select
                    v-model="document.statusId"
                    :items="statusOptions"
                    label="Status"
                    item-value="id"
                    item-text="name"
                    dense
                    no-data-text="Brak statusów do zmiany."
                    :disabled="isReadOnly"
                />
            </v-col>
        </v-row>
    </v-container>
</template>


<script>
import dateFormatter from '@/mixins/dateFormatter'

export default {
    name: 'DetailsTab',
    mixins: [
        dateFormatter
    ],
    props: {
        document: {
            type: Object,
            default: null,
        },
        validation: {
            type: Object,
            default: () => ({}),
        },
        action: {
            type: String,
            default: null
        },
        isReadOnly: {
            type: Boolean,
        },
        canEditAsAdmin: {
            type: Boolean
        },
    },

    data() {
        return {
            loading: {
                types: false,
                departments: false
            },
            proposedDatePicker: false,
            proposedDate: null,
        }
    },
    computed: {
        productionDepartments() {
            const allDepartments = this.$store.state.documents.documentsOrders.productionDepartments
            const selectedId = this.document.productionDepartmentId

            if (!allDepartments) return []

            // Get visible departments (showAtDocOrders = true)
            const visibleDepartments = allDepartments.filter(dept => dept.showAtDocOrders === true)

            if (selectedId) {
                const selectedDept = allDepartments.find(d => d.id === selectedId)

                if (selectedDept && !selectedDept.showAtDocOrders) {
                    return [...visibleDepartments, selectedDept]
                }
            }

            return visibleDepartments
        },
        types() {
            const allTypes = this.$store.state.documents.documentsOrders.types
            const selectedId = this.document.typeId

            if (!allTypes) return []

            // Get visible types (isVisible = true)
            const visibleTypes = allTypes.filter(type => type.isVisible === true)

            if (selectedId) {
                const selectedType = allTypes.find(t => t.id === selectedId)

                if (selectedType && !selectedType.isVisible) {
                    return [...visibleTypes, selectedType]
                }
            }

            return visibleTypes
        },
        validationState() {
            const fields = [
                'productionDepartmentId',
                'typeId',
                'proposedDate',
            ]
            const provided = this.validation || {}

            return fields.reduce((acc, field) => {
                const entry = provided[field] || {}

                acc[field] = {
                    error: Boolean(entry.error),
                    messages: Array.isArray(entry.messages) ? entry.messages : []
                }

                return acc
            }, {})
        },
        statusOptions() {
            const current = this.document?.status
            const allowed = this.document?.status?.followingStatusesAllowed || []

            return [
                ...allowed.map(({ id, name }) => ({ id, name })),
                ...(current ? [{ id: current.id, name: current.name }] : [])
            ]
        },
        showStatusSelector() {
            return Boolean(this.document?.id && this.canEditAsAdmin)
        }
    },
    methods: {
        emitFieldBlur(field) {
            this.$emit('field-blur', field)
        },
        proposedDateHandler(date) {
            this.proposedDate = date
            this.document.proposedDate = date
            this.proposedDatePicker = false
        }
    }
}
</script>